import { z } from "zod";

const internalHrefSchema = z.string().min(1).refine(
  (value) => value.startsWith("/") || value.startsWith("#"),
  "Navigation hrefs must be site-relative",
);

const navStatusSchema = z.enum(["active", "planned"]);

const navChildItemSchema = z.object({
  id: z.string().min(1),
  label: z.string().min(1),
  href: internalHrefSchema,
  description: z.string().min(1),
  status: navStatusSchema,
}).strict();

export const navItemSchema = z.object({
  id: z.string().min(1),
  label: z.string().min(1),
  href: internalHrefSchema,
  description: z.string().min(1),
  status: navStatusSchema,
  children: z.array(navChildItemSchema).optional(),
}).strict();

export const landingConfigSchema = z.object({
  imageSrc: internalHrefSchema,
  imageAlt: z.string().min(1),
  heightVh: z.number().min(50).max(100),
  dashboardSnapThreshold: z.number().min(0).max(1),
  headline: z.string().min(1),
  manifesto: z.string().min(1),
  primaryActionLabel: z.string().min(1),
  primaryActionHref: internalHrefSchema,
}).strict();

export const siteConfigSchema = z.object({
  brand: z.object({
    name: z.string().min(1),
    tagline: z.string().min(1),
  }).strict(),
  landing: landingConfigSchema,
  navigation: z.array(navItemSchema),
  developerNavigation: z.array(navItemSchema),
}).strict();
